import DocumentDO = App.Data.Explorer.DocumentDO;
import { activeFiltersWithoutDisplayOnlyFields } from "@/modules/explorer/composables/filterDisplaySettings";

//This object holds all the keys and values for the data table that dont require a data refresh in combination with the new prefetch.
export const DISPLAY_ONLY_SETTINGS = {
	split_prediction: true,
	show_change_absolute: true,
	show_change_relative_to_current: true,
	is_comparison_nested: true,
	show_total_values: true,
	show_row_numbers: true,
	pivot_dimension: null,
};

export const docWithAllDisplaySettingsEnabled = (
	doc: DocumentDO
): DocumentDO => {
	const normalised: DocumentDO = {
		...doc,
		data_tables: [
			{
				...doc.data_tables[0],
				...DISPLAY_ONLY_SETTINGS,
			},
		],
	};

	normalised.active_filters = activeFiltersWithoutDisplayOnlyFields(
		normalised.active_filters
	);

	return normalised;
};

export const dataIdentityKey = (doc: DocumentDO): string => {
	const normalised = docWithAllDisplaySettingsEnabled(
		doc
	) as Partial<DocumentDO>;

	delete normalised.uuid;
	delete normalised.parent_uuid;

	return JSON.stringify(normalised);
};

export const requestIdentityKey = (doc: DocumentDO): string => {
	const normalised: Partial<DocumentDO> = { ...doc };

	normalised.active_filters = activeFiltersWithoutDisplayOnlyFields(
		normalised.active_filters
	);

	delete normalised.uuid;
	delete normalised.parent_uuid;

	return JSON.stringify(normalised);
};

export const metricKeys = (doc: DocumentDO): string[] =>
	(doc.data_tables[0]?.metrics ?? []).map((metric) => metric.name_clean);

export const reducibleIdentityKey = (doc: DocumentDO): string => {
	const normalised = docWithAllDisplaySettingsEnabled(
		doc
	) as Partial<DocumentDO>;

	delete normalised.uuid;
	delete normalised.parent_uuid;

	normalised.data_tables = (normalised.data_tables ?? []).map((table, index) =>
		index === 0 ? { ...table, metrics: [] } : table
	);

	return JSON.stringify(normalised);
};
